import { css } from "styled-components";

export const tooltipStyle = css`
    .dit-components-tooltip-content {
        a {
            color: var(--dit-brand-color-neutral-00--map);
        }
    }
`;
